import { Component } from '@angular/core';
import { CompanyService } from '../company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { ModuleService } from '../../../admin/module/module.service';
import { AuthenticationService } from '../../../../auth/authentication.service';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-show-company',
  templateUrl: 'show-company.component.html',
  styleUrls: ['show-company.component.scss'],
})
export class ShowCompanyComponent {

  public company: any = {};
  public parentId = '';
  public users = [];

  permissions;
  permissionSel;

  pesquisas;
  pesquisaSel;

  settings = {
    actions: {
      columnTitle: 'Ações',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'personificar',
          title: '<i class="nb-shuffle"></i>',
        },
      ]
    },
    mode: 'external',
    columns: {
      id: {
        title: 'ID',
        type: 'string',
        filter: false
      },
      firstName: {
        title: 'Nome',
        type: 'string',
      },
      email: {
        title: 'E-mail',
        type: 'string',
      },
      isOwner: {
        title: 'Owner',
        type: 'boolean',
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private companyService: CompanyService, private route: ActivatedRoute,
    private toastrService: NbToastrService, private router: Router, private moduleService: ModuleService,
    private authenticationService: AuthenticationService, private location: Location) {
    this.parentId = this.route.snapshot.params.parentId;
    this.getCompany(this.parentId);
    this.getUsers(this.parentId);
    this.createPermissions();
    this.getPesquisas();
  }

  delete() {
    this.companyService.remove(this.parentId).toPromise().then(result => {
      this.toastrService.show('Conta', 'Excluido com sucesso ',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.goBack();
    });
  }

  copy() {
    if (this.pesquisaSel) {
      let obj: any = {};
      obj.list = this.pesquisaSel.map(a => a.id);
      this.companyService.copyPesquisa(this.parentId, obj).toPromise().then(result => {
        this.toastrService.show('Pesquisas', 'Copiado com sucesso ',
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      })

    }
  }

  cloneBseDemo() {
    this.companyService.createBaseDemo(this.parentId).toPromise().then(result => {
      this.toastrService.show('Pesquisas', 'Copiado com sucesso ',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    })
  }

  getPesquisas() {
    this.companyService.getPesquisa().toPromise().then(resilt => {
      this.pesquisas = [];
      this.pesquisas = resilt.body;
      this.pesquisaSel = [];
    })
  }

  createPermissions() {

    this.permissions = [
      {
        id: 'ROLE_INTERNAl_SEARCH',
        description: 'Pesquisa interna'
      },
      {
        id: 'ROLE_INDICATOR',
        description: 'Indicadores'
      },
      {
        id: 'ROLE_INDICATOR_PENDENCY',
        description: 'Home page'
      },
      {
        id: 'ROLE_HELP_CENTER',
        description: 'Central de ajuda'
      },
      {
        id: 'ROLE_PROJECTS',
        description: 'Projetos'
      },
      {
        id: 'ROLE_EMPLOYEE_HEALTH_SCORE',
        description: 'Health Score'
      },
      {
        id: 'ROLE_OKR',
        description: 'OKR'
      },
      {
        id: 'ROLE_ONE_ON_ONE',
        description: '1:1'
      }
    ];

    this.permissionSel = [];

    this.companyService.checkPermission(this.parentId).toPromise().then(result => {
      result.body.forEach(role => {
        for (let i = 0; i < this.permissions.length; i++) {
          const pp = this.permissions[i];
          if (pp.id === role) {
            this.permissionSel.push(pp);
            this.permissions.splice(i, 1);
          }
        }
      });
    });
  }

  updatePerm() {
    if (this.permissionSel != null) {
      let obj: any = {};
      obj.authorities = this.permissionSel.map(a => a.id);
      this.companyService.updatePermission(this.parentId, obj).toPromise().then(result => {
        this.toastrService.show('Permissões', 'Atualizado com sucesso ',
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      });
    }
  }

  getCompany(parentId) {
    this.companyService.find(this.parentId).toPromise().then(response => {
      this.company = response.body;
    });
  }

  saveCompany() {
    this.companyService.create(this.parentId, this.company).toPromise().then(result => {
      this.toastrService.show('Parametros de pagamento', 'Atualizado com sucesso ',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getCompany(this.parentId);
    });
  }

  controlAccount(status) {
    this.companyService.controlAccount(this.parentId, status).toPromise().then(result => {
      this.toastrService.show('Usuários', 'Atualizado com sucesso ',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getCompany(this.parentId);
    });
  }

  getUsers(parentId) {
    this.companyService.getUsers(this.parentId).toPromise().then(response => {
      this.users = response.body
    });
  }

  goBack() {
    this.router.navigate(['pages/internal-admin/company']);
  }

  onCustom(event) {
    if (event.action == 'personificar') {
      this.authenticationService.impersonate(this.company.id, event.data.id).subscribe(() => {
        this.router.navigateByUrl('/').then(() => {
          this.location.replaceState('/');
          window.location.reload();
        });
      });
    }
  }

}
